// Google Maps API loader utility
let isLoaded = false;
let loadPromise: Promise<void> | null = null;

export const loadGoogleMapsAPI = (): Promise<void> => {
  // Return existing promise if already loading
  if (loadPromise) {
    return loadPromise;
  }

  // Return resolved promise if already loaded
  if (isLoaded) {
    return Promise.resolve();
  }

  // Start loading
  
  loadPromise = new Promise((resolve, reject) => {
    // Check if Google Maps is already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      isLoaded = true;
      resolve();
      return;
    }

    // Get API key from environment variables
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    
    if (!apiKey) {
      const error = new Error('Google Maps API key not found. Please set VITE_GOOGLE_MAPS_API_KEY in your environment variables.');
      console.error(error.message);
      reject(error);
      return;
    }

    // Create script element
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initGoogleMaps`;
    script.async = true;
    script.defer = true;

    // Set up callback
    (window as any).initGoogleMaps = () => {
      isLoaded = true;
      delete (window as any).initGoogleMaps;
      resolve();
    };

    // Handle script load errors
    script.onerror = () => {
      loadPromise = null;
      const error = new Error('Failed to load Google Maps API');
      console.error(error.message);
      reject(error);
    };

    // Add script to document
    document.head.appendChild(script);
  });

  return loadPromise;
};

export const isGoogleMapsLoaded = (): boolean => {
  return isLoaded && !!(window.google && window.google.maps && window.google.maps.places);
};

export const waitForGoogleMaps = (): Promise<void> => {
  if (isGoogleMapsLoaded()) {
    return Promise.resolve();
  }
  
  return loadGoogleMapsAPI();
};